import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState, useEffect } from 'react';
export default (function () {
  var threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 20;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      shrinked = _useState2[0],
      setShrinked = _useState2[1];

  function setHeaderSize() {
    var distanceY = window.pageYOffset;
    setShrinked(distanceY > threshold);
  }

  useEffect(function () {
    window.addEventListener('scroll', setHeaderSize);
    return function () {
      return window.removeEventListener('scroll', setHeaderSize);
    };
  }, []);
  return shrinked;
});